<atlas-form id="billingTermsDataForm" [formGroup]="form">
	<atlas-grid>
		<atlas-row>
			<atlas-col lg="12">
				<atlas-section
					hide-optional=""
					[header]="
						'CREATE_RECEIPT.BILLING_TERMS_DATA_STEP.INTEREST_TITLE'
							| translate
					"
				>
					<atlas-grid>
						<atlas-row>
							<atlas-col lg="12">
								<atlas-layout gap="2">
									<atlas-text muted="true">
										{{
											"CREATE_RECEIPT.BILLING_TERMS_DATA_STEP.INTEREST_SUBTITLE"
												| translate
										}}
									</atlas-text>
								</atlas-layout>
							</atlas-col>
						</atlas-row>
						<atlas-row>
							<atlas-col lg="3">
								<atlas-layout gap="2">
									<atlas-percentage
										#interestPercentRef
										appAtlasFormElement
										[label]="
											'CREATE_RECEIPT.BILLING_TERMS_DATA_STEP.INTEREST_PERCENTAGE'
												| translate
										"
										formControlName="interestPercent"
										inputmode="numeric"
										max-value="10,00"
										[maxValueErrorMessage]="
											'CREATE_RECEIPT.BILLING_TERMS_DATA_STEP.ERROR_MAX_VALUE'
												| translate
										"
										data-testid="receipt-wizard-interest-percent"
									>
									</atlas-percentage>
								</atlas-layout>
							</atlas-col>
							<atlas-col lg="3">
								<atlas-layout gap="2">
									<atlas-money
										appAtlasFormElement
										formControlName="interestValue"
										[label]="
											'CREATE_RECEIPT.BILLING_TERMS_DATA_STEP.INTEREST_VALUE'
												| translate
										"
										inputmode="decimal"
										maxlength="15"
										data-testid="receipt-wizard-interest-value"
									>
									</atlas-money>
								</atlas-layout>
							</atlas-col>
						</atlas-row>
					</atlas-grid>
				</atlas-section>
				<atlas-section
					hide-optional=""
					[header]="
						'CREATE_RECEIPT.BILLING_TERMS_DATA_STEP.FINE_TITLE'
							| translate
					"
				>
					<atlas-grid>
						<atlas-row>
							<atlas-col lg="12">
								<atlas-layout gap="2">
									<atlas-text muted="true">
										{{
											"CREATE_RECEIPT.BILLING_TERMS_DATA_STEP.FINE_SUBTITLE"
												| translate
										}}
									</atlas-text>
								</atlas-layout>
							</atlas-col>
						</atlas-row>
						<atlas-row>
							<atlas-col lg="4">
								<atlas-layout gap="2">
									<atlas-toggle
										default-value="percentageFine"
										required="true"
									>
										<atlas-toggle-item
											(atlas-toggle-item-change)="
												toggleCheckedFine($event)
											"
											[checked]="true"
											[label]="
												'CREATE_RECEIPT.BILLING_TERMS_DATA_STEP.PERCENTAGE'
													| translate
											"
											value="percentageFine"
											data-testid="receipt-wizard-fine-percentage-toggle"
										></atlas-toggle-item>
										<atlas-toggle-item
											[label]="
												'CREATE_RECEIPT.BILLING_TERMS_DATA_STEP.FIXED_VALUE'
													| translate
											"
											value="fixedFine"
											data-testid="receipt-wizard-fine-fixed-value-toggle"
										></atlas-toggle-item>
									</atlas-toggle>
								</atlas-layout>
							</atlas-col>
						</atlas-row>
						<atlas-row>
							@if (toggleSelectedPercentageFine) {
								<atlas-col lg="3">
									<atlas-layout gap="2">
										<atlas-text>{{
											"CREATE_RECEIPT.BILLING_TERMS_DATA_STEP.FINE_PERCENTAGE"
												| translate
										}}</atlas-text>
										<atlas-percentage
											#finePercentRef
											appAtlasFormElement
											formControlName="finePercent"
											inputmode="numeric"
											max-value="99,99"
											[maxValueErrorMessage]="
												'CREATE_RECEIPT.BILLING_TERMS_DATA_STEP.ERROR_MAX_PERCENTAGE_FINE'
													| translate
											"
										>
										</atlas-percentage>
									</atlas-layout>
								</atlas-col>
							}
							<atlas-col lg="3">
								<atlas-layout gap="2">
									<atlas-text>{{
										"CREATE_RECEIPT.BILLING_TERMS_DATA_STEP.FINE_VALUE"
											| translate
									}}</atlas-text>
									<atlas-money
										appAtlasFormElement
										formControlName="fineValue"
										inputmode="decimal"
										data-testid="receipt-wizard-fine-fixed-value"
									>
									</atlas-money>
								</atlas-layout>
							</atlas-col>
						</atlas-row>
					</atlas-grid>
				</atlas-section>
				<atlas-section
					hide-optional=""
					[header]="
						'CREATE_RECEIPT.BILLING_TERMS_DATA_STEP.DISCOUNT_TITLE'
							| translate
					"
				>
					<atlas-grid>
						<atlas-row>
							<atlas-col lg="12">
								<atlas-layout gap="2">
									<atlas-text
										muted="true"
										[innerHTML]="
											'CREATE_RECEIPT.BILLING_TERMS_DATA_STEP.DISCOUNT_SUBTITLE'
												| translate
													: {
															extraText:
																textSubtitleDiscount
													  }
										"
									>
									</atlas-text>
								</atlas-layout>
							</atlas-col>
						</atlas-row>
						<atlas-row>
							<atlas-col lg="4">
								<atlas-layout gap="2">
									<atlas-toggle
										default-value="percentageDiscount"
										required="true"
									>
										<atlas-toggle-item
											(atlas-toggle-item-change)="
												toggleCheckedDiscount($event)
											"
											[checked]="true"
											[label]="
												'CREATE_RECEIPT.BILLING_TERMS_DATA_STEP.PERCENTAGE'
													| translate
											"
											value="percentageDiscount"
											data-testid="receipt-wizard-discount-percentage-toggle"
										></atlas-toggle-item>
										<atlas-toggle-item
											[label]="
												'CREATE_RECEIPT.BILLING_TERMS_DATA_STEP.FIXED_VALUE'
													| translate
											"
											value="fixedDiscount"
											data-testid="receipt-wizard-discount-fixed-value-toggle"
										></atlas-toggle-item>
									</atlas-toggle>
								</atlas-layout>
							</atlas-col>
						</atlas-row>
						<atlas-row>
							@if (toggleSelectedPercentageDiscount) {
								<atlas-col lg="3">
									<atlas-layout gap="2">
										<atlas-text>
											{{
												"CREATE_RECEIPT.BILLING_TERMS_DATA_STEP.DISCOUNT_PERCENTAGE"
													| translate
											}}
											<atlas-icon-button
												icon="info"
												theme="primary"
												size="auto"
												popover-title=""
												[popoverContent]="
													'CREATE_RECEIPT.BILLING_TERMS_DATA_STEP.POPOVER_DISCOUNT_PERCENTAGE'
														| translate
												"
												tooltip-placement="bottom"
												tooltip-trigger="hover focus"
											></atlas-icon-button
										></atlas-text>
										<atlas-percentage
											#discountPercentRef
											appAtlasFormElement
											formControlName="discountPercent"
											inputmode="numeric"
											data-testid="receipt-wizard-discount-percentage"
										>
										</atlas-percentage>
									</atlas-layout>
								</atlas-col>
							}
							<atlas-col lg="3">
								<atlas-layout gap="2">
									<atlas-text>{{
										"CREATE_RECEIPT.BILLING_TERMS_DATA_STEP.DISCOUNT_VALUE"
											| translate
									}}</atlas-text>
									<atlas-money
										#discountValueRef
										appAtlasFormElement
										inputmode="decimal"
										formControlName="discountValue"
										data-testid="receipt-wizard-discount-fixed"
									>
									</atlas-money>
								</atlas-layout>
							</atlas-col>
						</atlas-row>
						<atlas-row>
							<atlas-col lg="4">
								<atlas-layout gap="2">
									<atlas-select
										#atlasSelectLimitDaysDiscount
										appAtlasFormElement
										[label]="
											'CREATE_RECEIPT.BILLING_TERMS_DATA_STEP.LIMIT_DAYS_DISCOUNT'
												| translate
										"
										[popoverContent]="
											'CREATE_RECEIPT.BILLING_TERMS_DATA_STEP.POPOVER_LIMIT_DAYS_DISCOUNT'
												| translate
										"
										formControlName="limitDaysDiscount"
										(atlas-select-change)="
											setSelectedLimitDaysDiscount()
										"
										required
									>
										@for (
											option of selectOptionsDiscount;
											track option
										) {
											<atlas-option
												[label]="option.label"
												[value]="option.value"
											></atlas-option>
										}
									</atlas-select>
								</atlas-layout>
							</atlas-col>
						</atlas-row>
					</atlas-grid>
				</atlas-section>
			</atlas-col>
		</atlas-row>
	</atlas-grid>
</atlas-form>
